import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { from, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CustomizedTimeDialog } from 'src/app/shared/service/dialog-loaders';
import { LazyDialogService } from 'src/app/shared/service/lazy-dialog.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
// 僅型別。改回 value import 會讓 Material datepicker（102 KB）重回 initial bundle ——
// 本服務是 providedIn:'root' 且被 app.module 的 CustomizeFormModule 靜態可達。
import type { CustomizedTimeDialogResInterface } from './customized-time-dialog.component';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CustomizedTimeService {
  private isH5!: boolean;

  constructor(private lazyDialog: LazyDialogService, private layout: LayoutService) {
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(v => (this.isH5 = v));
  }

  /**
   * 彈窗改為動態載入後，開啟本身變成非同步，但這裡刻意維持回傳 `Observable<number[]>`
   * —— 呼叫端（customize-select）零改動。
   */
  show(startDate: number, endDate: number, useUTC0: boolean = false): Observable<number[]> {
    return from(
      this.lazyDialog.openPopup<unknown, unknown, CustomizedTimeDialogResInterface>(CustomizedTimeDialog, {
        inAnimation: this.isH5 ? 'fadeInUp' : undefined,
        outAnimation: this.isH5 ? 'fadeOutDown' : undefined,
        position: this.isH5 ? { bottom: '0px' } : undefined,
        speed: 'faster',
        autoFocus: false,
        data: { startDate, endDate, useUTC0 },
      }),
    ).pipe(
      // chunk 載入失敗時 ref 為 null，發出一次 undefined 走下方的「放棄」分支，
      // 與使用者關閉彈窗的結果一致，不阻斷篩選流程。
      switchMap(ref => (ref ? ref.afterClosed() : of(undefined))),
      map((v?: CustomizedTimeDialogResInterface) => {
        if (v?.startTime && v?.endTime) {
          return [v.startTime, v.endTime];
        } else {
          //用户放弃或者无效值
          return [0, 0];
        }
      }),
    );
  }
}
